export enum EnrollmentStatusTypes {
  NotStarted = 1,
  Pending = 2,
  Complete = 3,
  SelfService = 4,
}
